// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_watcher_count-module__container--3P-wl"};